/* Galería del producto: puntos de paginación sincronizados con el slider de Dawn */
document.querySelectorAll('.domu-gallery__dots').forEach(function (dots) {
  var gallery = dots.closest('media-gallery');
  var track = gallery && gallery.querySelector('.product__media-list');
  if (!track) return;
  var slides = Array.from(track.querySelectorAll('.product__media-item'));
  if (slides.length < 2) { dots.style.display = 'none'; return; }
  slides.forEach(function (s, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Imagen ' + (i + 1));
    b.addEventListener('click', function () { track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); });
    dots.appendChild(b);
  });
  var update = function () {
    var w = slides[0].offsetWidth || 1;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var i = Math.round(track.scrollLeft / (w + gap));
    Array.from(dots.children).forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
  };
  track.addEventListener('scroll', function () { clearTimeout(dots._t); dots._t = setTimeout(update, 60); }, { passive: true });
  update();
});

/* Envío estimado: fechas */
document.querySelectorAll('.domu-eta').forEach(function (el) {
  var days = el.dataset.days.split(',').map(function (s) { return s.trim(); });
  var months = el.dataset.months.split(',').map(function (s) { return s.trim(); });
  var fmt = function (d) {
    var dn = days[(d.getDay() + 6) % 7], mn = months[d.getMonth()], dd = d.getDate(), mm = ('0' + (d.getMonth() + 1)).slice(-2);
    switch (el.dataset.format) {
      case 'day_mm_dd': return dn + ' ' + mn + ' ' + dd;
      case 'dd_mm': return dd + ' ' + mn;
      case 'mm_dd': return mn + ' ' + dd;
      case 'dd_mm_numeric': return dd + '/' + mm;
      case 'day_dd_mm_numeric': return dn + ' ' + dd + '/' + mm;
      default: return dn + ' ' + dd + ' ' + mn;
    }
  };
  var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
  var msg = el.querySelector('.domu-eta__msg');
  msg.innerHTML = msg.innerHTML.replace('[start_date]', fmt(add(parseInt(el.dataset.min, 10)))).replace('[end_date]', fmt(add(parseInt(el.dataset.max, 10))));
});

/* "Comprar ahora" (botón secundario) e "ir directo al checkout" en el botón principal */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-buy-now]');
  var skip = e.target.closest('[data-skip-cart="true"] .product-form__submit');
  if (!btn && !skip) return;
  var form = (btn || skip).closest('product-form').querySelector('form');
  e.preventDefault();
  e.stopPropagation();
  fetch('/cart/add.js', { method: 'POST', body: new FormData(form) }).then(function (r) {
    if (r.ok) location.href = '/checkout'; else form.requestSubmit();
  });
}, true);
